import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { Link, RowContainer } from '../../shared/styles';

import {
  ActionColumn,
  Dot,
  NameColumn,
  PartnershipColumn,
  MemberCountColumn,
} from './styles';
import CompaniesContext from './context';

export default function Company({ company }) {
  const {
    id,
    name,
    members,
    partnership,
    cta,
  } = company;

  const { dispatch } = React.useContext(CompaniesContext);

  const showModal = type => e => {
    e && e.preventDefault();

    dispatch({ type, payload: company });
  };

  return (
    <RowContainer>
      <NameColumn>{name}</NameColumn>
      <PartnershipColumn>{_.get(partnership, 'type')}</PartnershipColumn>
      <MemberCountColumn>{members.length}</MemberCountColumn>
      <ActionColumn>
        <Link href={`/lwadmin/company/${id}`}>View</Link>
        |
        <Link href="#" onClick={showModal('editCompany')}>Edit</Link>
        |
        <Link href="#" onClick={showModal('brandCompany')}>Brand</Link>
        |
        <Link href="#" onClick={showModal('ctaCompany')}>
          CTA
          { cta && <Dot /> }
        </Link>
        {partnership && (
          <>
            |
            <Link href={`/lwadmin/partnership/${partnership.id}/wires`}>View Partnership</Link>
          </>
        )}
      </ActionColumn>
    </RowContainer>
  );
}

Company.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    administratorEmail: PropTypes.string,
    websiteUrl: PropTypes.string,
    members: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
    partnership: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
    }),
    cta: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      message: PropTypes.string,
      text: PropTypes.string,
      link: PropTypes.string,
    }),
  }).isRequired,
};
